require('array.prototype.find').shim();
require('array.prototype.findindex').shim();
require('url-polyfill');

import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from '@dialogexe/cw-website-store';

import './src/layouts/assets/icons';
import './src/layouts/assets/images';

exports.onClientEntry = require('./gatsby-builder/bootstrap/browser').bootstrap;

exports.replaceRouterComponent = ({ history }) => {
    const store = createStore();

    const ConnectedRouterWrapper = ({ children }) => (
        <Provider store={store}>
            <Router history={history}>{children}</Router>
        </Provider>
    );

    return ConnectedRouterWrapper;
};



// WEBPACK FOOTER //
// ./gatsby-browser.js